import { quickNav, siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20empty%20banquet%20room%20with%20long%20table%2C%20dim%20warm%20amber%20light%2C%20half%20empty%20wine%20glasses%2C%20rain%20streaked%20window%2C%20lonely%20mysterious%20atmosphere%2C%20muted%20warm%20tones%2C%20painterly%2C%20no%20people%2C%20soft%20shadows&width=1920&height=1080&seq=hero-adultery-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-28 text-center md:px-6 md:py-40">
        <span className="rounded-full border border-background-50/35 px-4 py-1 font-label text-xs tracking-[0.3em] text-background-100">
          {siteInfo.originalName} · 剧情资料页
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          《{siteInfo.name}》剧情介绍
          <span className="mt-3 block text-xl font-semibold text-accent-200 md:text-2xl">
            从故事梗概到结局，一次看懂
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          本站整理《{siteInfo.name}》系列的故事梗概、分部（分集）剧情完整版、人物关系与结局深度解析，帮你在追剧之前先摸清脉络，从开头到结局一次看懂。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#episodes"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            直接看分集剧情
          </a>
          <a
            href="#ending"
            className="whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            跳转结局解析
          </a>
        </div>

        <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="页面分区快捷入口">
          {quickNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="whitespace-nowrap rounded-full border border-background-50/25 px-3 py-1 text-xs text-background-100/90 transition-colors hover:border-accent-300 hover:text-accent-200"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
}